export default {
  INIT_PORTLET_ID: (state, portletId) => {
    state.portletId = portletId;
  },
  SET_TIME: (state, time) => {
    state.time = time;
  },
  SET_ACTIVE_MAP_BUTTON: (state, id) => {
    state.activeMapButton = id;
  },
  SET_STREETVIEW: (state, status) => {
    state.streetview = status;
  },
  SET_ZOOM_STATE: (state, newZoomState) => {
    state.zoomState = newZoomState;
  },
  WIDE_ASIDE_PANEL_OPEN: (state) => {
    state.wideAsidePanel = true;
  },
  WIDE_ASIDE_PANEL_CLOSE: (state) => {
    state.wideAsidePanel = false;
  },
  SET_COMPONENT_SELECTION_DROPDOWN_OPEN: (state, value) => {
    state.componentSelectionDropdownOpen = value;
  },
  SET_ESC_CLICKED: (state, value) => {
    state.escClicked = value;
  },
};
